import {useTranslation} from "react-i18next";
import React, {useEffect, useState} from "react";
import {usePDF} from "@react-pdf/renderer";
import { saveAs } from 'file-saver';
import {PDFFile} from "./offers/PDFFile";
import PopupForm from "../../components/ui/PopupForm";
// import PropTypes from "prop-types";


const RenderDataToPDF = ({dataToRender, processName, dispatch, popupError, popupInitial}) => {
    const { t } = useTranslation()
    const [popupPDF, setPopupPDF] = useState(popupInitial)
    const popupLoadingPDF = {
        show: true,
        variant: 'loading',
        title: t('popups.generate_pdf.loading'),
        message: t("popups.generate_pdf.progress")
    }

    const popupGeneratePDF = {
        show: true,
        variant: 'success',
        leftBtn: t('common.button.download'),
        rightBtn: t('common.button.cancel'),
        title: t('popups.generate_pdf.title'),
        message: t("popups.generate_pdf.success")
    }
    const document = <PDFFile doc={dataToRender} />
    const [instance, updateInstance] = usePDF({document})

    useEffect(() => {
        if (instance.loading) {
            setPopupPDF(popupLoadingPDF)
        } else if (instance.error) {
            setPopupPDF(popupError)
        } else {
            setPopupPDF(popupGeneratePDF)
        }
    }, [instance]);

    const handlePopup = async popupDict => {
        if (popupDict.type === 'save') {
            const name_pdf_index = dataToRender.typeData === 'quote' ? dataToRender.quoteID : dataToRender.estimate
            await saveAs(instance.url, `${processName}_${name_pdf_index}.pdf`);
            // window.location.assign(instance.url)
            await setPopupPDF(popupInitial)
            await dispatch(false)
        }
        if (popupDict.type === 'ok') {
            dispatch({type: "SET_POPUP", popup: popupError})
        }
        if (popupDict.type === 'cancel') {
            setPopupPDF(popupInitial)
            dispatch(false)
        }
    };

    return popupPDF.show ? <PopupForm
        handlePopup={handlePopup}
        variant={popupPDF.variant}
        title={t(popupPDF.title)}
        message={t(popupPDF.message)}
        leftBtn={popupPDF.leftBtn}
        rightBtn={popupPDF.rightBtn}
        okBtn={popupPDF.okBtn}
        context={popupPDF.context}
    /> : null;

}


export {
    RenderDataToPDF,
}
